import { Base64File, FileInputType } from '@cksoftware/react-base';

export type QuickChat = {
  Name: string;
};

export type PriceIncrement = {
  Amount: number;
};

export enum AuctionStatus {
  Consigning = 1,
  Canceled = 2,
  Selling = 3,
  Deleted = 4,
  Sold = 5
}

export type AuctionTableItem = {
  Id: number;
  Name: string;
  SaleDate: string;
  SaleTime: string;
};

export type AuctionSearchRequest = {
  Name?: string;
  Date?: Date;
  Status?: AuctionStatus;
  AuctionType?: AuctionType;
  ConsignorName?: string;
  FieldMan?: string;
  BuyerName?: string;
};

export type AuctionFormModel = {
  Id: number;
  Name?: string;
  SupportPhoneNumber: string;
  SaleStatusId: number;
  SaleStatus: string;
  HideBidBox: boolean;
  HideFromMarketReport: boolean;
  HideChat: boolean;
  HideAds: boolean;
  AllowChatToAll: boolean;
  Description: string;
  ListingMarketId: number;
  LiveStreamId: number | undefined;
  AudioStreamId: number | undefined;

  SaleType: number;
  SaleFunctionalTypeString: string;
  SaleDisplayTypes: string[];
  SaleDate: string;
  SaleTime: string;
  SaleTimeZone: string;
  QuickChats: QuickChat[];
  PriceTypeId: number;
  PriceIncrements: PriceIncrement[];
  AllowedLotType: AuctionType;
  AdditionalTermsAndConditions: string;
  CustomerText: string;
  CustomerUrl: string;
  SaleCatalogueText: string;
  SaleCatalogueUrl: string;
  VideoText: string;
  VideoUrl: string;
  WebsiteLinkText: string;
  WebsiteLinkUrl: string;
  InfoDocumentText: string;
  InfoDocument: FileInputType[];
  PromotionalImageId: string;
};

export type UploadLotModel = {
  AuctionId: number;
  ReplaceLots: boolean;
  Files: Base64File[];
};

export enum AuctionType {
  None = 0,
  Purebred = 1,
  Presort = 2,
  Direct = 3,
  Event = 4,
  Timed = 5
} // todo get these from the backend

export enum SaleStatus {
  Consigning = 1,
  Canceled = 2,
  Selling = 3,
  Deleted = 4,
  Sold = 5
} // todo get these from the backend

export type ChatLogEntry = {
  Id: number;
  UserName: string;
  BuyerName: string;
  MessageText: string;
  Channel: string;
  MessageTime: string; // ISO string from DateTime serialization
  AuctionId: number;
};

export enum LotStatus {
  NotSold = 1,
  Selling = 2,
  Sold = 3
}
